import { createActions, handleActions } from 'redux-actions'
import Immutable, { List, Map } from 'immutable'
import fetch from '@request/fetch'

const WEBSITE_SEARCH = 'WEBSITE_SEARCH' // 获取网址/域名/IP管理列表
const WEBSITE_CHAIN_GET = 'WEBSITE_CHAIN_GET' // 根据网址获取跳转网址的链路信息
const WHITE_WEBSITE_POST = 'WHITE_WEBSITE_POST' // 新增网址白名单
const WEBSITE_DELETE = 'WEBSITE_DELETE' // 删除网址
const WEBSITES_UPDATE = 'WEBSITES_UPDATE' // 批量修改有效期
const BLACK_WEBSITE_POST = 'BLACK_WEBSITE_POST' // 新增网址黑名单
const WEBSITE_UPDATE = 'WEBSITE_UPDATE' // 修改单个数据
const STORE_WEBSITE = 'STORE_WEBSITE' // 存储网址信息
const CLEAR_WEBSITE = 'CLEAR_WEBSITE' // 清空已请求的网址信息
const DELETE_WEBSITE = 'DELETE_WEBSITE' // 删除已存储的网址

const defaultState = Immutable.fromJS({
  websiteList: {
    list: [],
    total: 0
  },
  existWebsites: [] // 用来存放已经请求过的网址信息
})

export const websiteAction = createActions({
  WEBSITE_SEARCH: async params => {
    const result = await fetch.post(`/website/searchSites`, params)
    return result
  },
  WEBSITE_GET: async params => {
    const result = await fetch.post(`/website/getWebSite`, params)
    return result
  },
  WHITE_WEBSITE_POST: async params => {
    const result = await fetch.post(`/website/postWhiteWebSite`, params)
    return result
  },
  WEBSITE_DELETE: async params => {
    const result = await fetch.post(`/website/deleteWebSite`, params)
    return result
  },
  WEBSITES_UPDATE: async params => {
    const result = await fetch.post(`/website/updateWebSites`, params)
    return result
  },
  WEBSITE_CHAIN_GET: async params => {
    const result = await fetch.post(`/website/getWebSiteChain`, params)
    return result
  },
  BLACK_WEBSITE_POST: async params => {
    const result = await fetch.post(`/website/postBlackWebSite`, params)
    return result
  },
  WEBSITE_UPDATE: async params => {
    const result = await fetch.post(`/website/updateWebSite`, params)
    return result
  },
  STORE_WEBSITE: data => {
    return data
  },
  DELETE_WEBSITE: data => {
    return data
  },
  CLEAR_WEBSITE: () => {}
})

const reducer = handleActions(
  {
    [WEBSITE_SEARCH]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'websiteList',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    },
    [STORE_WEBSITE]: (state, action) => {
      let curState = state
      const data = action.payload
      curState = curState.update(
        'existWebsites',
        item => item.push(new Map(data))
      )
      return curState
    },
    [CLEAR_WEBSITE]: (state, action) => {
      let curState = state
      curState = curState.set(
        'existWebsites',
        new List()
      )
      return curState
    },
    [DELETE_WEBSITE]: (state, action) => {
      let curState = state
      const data = action.payload
      curState = curState.update(
        'existWebsites',
        item => item.map(value => new Map(value))
      )
      return curState
    }
  },
  defaultState
)

export default reducer
